import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import styles from './BottomTray.module.scss';

interface Props {
  closeTray: () => void;
}

const BottomTray = ({ children, closeTray }: PropsWithChildren<Props>) => {
  const [trayPosition, updateTrayPosition] = useState(-500);
  const trayRef = useRef<HTMLDivElement>(null);
  const visibleRef = useRef(false);

  useEffect(() => {
    const handleTransitionEnd = () => {
      if (visibleRef.current) {
        closeTray();
      }
    };

    if (trayRef.current) {
      updateTrayPosition(0);
      trayRef.current.addEventListener('transitionend', handleTransitionEnd, false);
    }

    return () => {
      trayRef.current?.removeEventListener('transitionend', handleTransitionEnd, false);
    };
  }, [closeTray]);

  const handleCloseTray = () => {
    visibleRef.current = true;
    if (trayRef.current) {
      updateTrayPosition(trayRef.current.offsetHeight * -1);
    }
  };

  return (
    <div className={styles.container}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={styles.opacScreen} onClick={handleCloseTray} />
      <div className={`${styles.tray}`} style={{ bottom: trayPosition }} ref={trayRef}>
        {children}
      </div>
    </div>
  );
};

export default BottomTray;
